// store.ts
import { configureStore } from '@reduxjs/toolkit';

import appReducer from './message/slice';
import fontReducer from './DynamicStyle/font';

const store = configureStore({
  reducer: {
    app: appReducer,
    font: fontReducer,
    
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
